import React from 'react';
import { Status } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, isEnumValid } from '@philips-internal/oswald-ui-utils';
import { TooltipTrigger } from '../../tooltip/tooltip-constants.js';
import { Tooltip } from '../../tooltip/tooltip.js';
function EventToken({ status, subtitle, title, onClick, onDoubleClick, onContextMenuClick }) {
    const elementClasses = {
        'c-event-token': true,
        [`is-${status}`]: isEnumValid(Status, status),
    };
    return (React.createElement("div", { className: classNames(elementClasses), onClick: onClick, onContextMenu: onContextMenuClick, onDoubleClick: onDoubleClick },
        React.createElement(Tooltip, { triggers: [TooltipTrigger.HOVER], value: MessageService.translate(status) },
            React.createElement("div", { className: "c-event-token__status", "x-contrast": "bg" })),
        React.createElement("div", { className: "c-event-token__data" },
            React.createElement("span", { className: "c-event-token__title u-truncate" }, MessageService.translate(title)),
            React.createElement("span", { className: "c-event-token__subtitle u-truncate" }, MessageService.translate(subtitle)))));
}
export { EventToken, };
//# sourceMappingURL=event-token.js.map